<script>
import Popup from '../../components/mineTable/popup.vue';
import StudyList from '../../components/studyList.vue';
export default {
    name: "vip",
    data() {
        return {
            menu: [
                {
                    name: '无限展览',
                    icon: require('@/assets/images/icon_vip_nav_01.png'),
                    text: '无需提前预订。出示会员卡，即可参观您心仪的展览，即使门票已售罄',
                },
                {
                    name: '商店折扣',
                    icon: require('@/assets/images/icon_vip_nav_02.png'),
                    text: '在所有 Ambassador + 商店享受 10% 折扣以及其他特别优惠。',
                },
                {
                    name: '课程阅读',
                    icon: require('@/assets/images/icon_vip_nav_03.png'),
                    text: '尽早预订Ambassador +学院课程的席位，无论您身在何处，这些课程都会将 Ambassador +的丰富性和严谨性带到博物馆和您的家中。',
                },
                {
                    name: '独家预览',
                    icon: require('@/assets/images/icon_vip_nav_04.png'),
                    text: '',
                },
            ],
            activeIndex: 0,
            detail: {
                exhibition: [],
                study: [],
            },
            viplist: [
                { name: '月度会员', price: '38.00', value: 1 },
                { name: '季度会员', price: '68.00', value: 2 },
                { name: '年度会员', price: '128.00', value: 3 },
            ],
            vipActiveIndex: null,
            isShowPopup: false,
            vipOrderCode: '', // 购买会员订单号
            // 支付方式列表
            payTypeList: [
                { id: 1, name: '支付宝' },
                { id: 2, name: '微信' },
                // { id: 3, name: 'Pay Pal' },
            ],
            paytype: 1,
            isLoadingQrcode: false,
            payQrcode: '',
        };
    },
    computed: {},
    components: {
        StudyList,
        Popup,
    },
    mounted() {
        // 获取会员页面列表
        this.getVipInfo();
    },
    destroyed() {},
    watch: {},
    methods: {
        // 获取会员页面列表
        getVipInfo() {
            this.$store.dispatch('getVipInfo').then((result) => {
                if (result.code === 100) { 
                    this.detail = result.data;
                }
            });
        },
        // 购买会员
        buyVip() {
            if (this.vipActiveIndex === null) {
                this.$showToast({ text: '请选择会员类型' });
                return;
            }
            this.$store.dispatch('buyVip', {
                type: this.viplist[this.vipActiveIndex].value,
                count: 1,
            }).then((result) => {
                if (result.code === 100) { 
                    this.isShowPopup = true;
                    this.vipOrderCode = result.data.order_code;
                    // 获取支付二维码
                    this.getVipQRCode();
                } else if (result.code == 90) { 
                    this.toLogin();
                } else {
                    this.$showToast({ text: result.msg || '购买失败' });
                }
            }).catch(() => {
                this.$showToast({ text: '购买失败' });
            });
        },
        // 获取二维码
        getVipQRCode() {
            if (!this.vipOrderCode) {
                this.$showToast({ text: '订单号不存在' });
                return;
            }
            this.isLoadingQrcode = true;
            // 获取支付二维码
            this.$store.dispatch('getShopOrderPay', {
                order_code: this.vipOrderCode,
                type: this.paytype,
            }).then((result) => {
                this.isLoadingQrcode = false;
                if (result.code == 100) {
                    // 显示支付二维码
                    this.payQrcode = result.data;
                } else if (result.code == 90) { 
                    this.toLogin();
                } else {
                    this.$showToast({ text: result.msg || '获取支付二维码失败' });
                }
            }).catch((err) => {
                this.isLoadingQrcode = false;
                this.$showToast({ text: err.message || '获取支付二维码失败' });
            });
        },
        // 选择支付方式
        choosePayType(id) {
            if (this.paytype === id) return;
            this.paytype = id;
            // 重新获取支付二维码
            this.getVipQRCode();
        },
        // 刷新支付状态
        refreshPayStatus() { 
            this.$store.dispatch('getShopOrderPayStatus', {
                order_code: this.vipOrderCode,
            }).then((result) => {
                if (result.code == 100) {
                    if (result.data == 1) {
                        this.$showToast({ text: '支付成功' });
                        this.isShowPopup = false;
                        // 更新用户信息
                        this.$store.dispatch('getUserinfo');
                    } else {
                        this.$showToast({ text: '支付未完成，请稍后再试' });
                    }
                } else if (result.code == 90) { 
                    this.toLogin();
                } else {
                    this.$showToast({ text: result.msg || '获取支付状态失败' });
                }
            }).catch((err) => {
                this.$showToast({ text: err.message || '获取支付状态失败' });
            });
        },
        // 跳转登录
        toLogin() { 
            this.$router.push({
                path: '/login',
                query: {
                    redirect: this.$route.fullPath
                }
            })
        },
    },
};
</script>

<template>
    <div class="vip">
        <div class="banner">
            <div class="layout_bg bg" :style="`background-image: url();`"></div>
            <div class="content layout_main">
                <p class="text">今天成为Ambassador<sup>+</sup>会员体验更多。</p>
            </div>
        </div>
        <div class="menu flex justify_center">
            <template v-for="(item, index) in menu">
                <div class="item layout_flex_center flex_column" :class="{active: activeIndex == index}" @click="activeIndex = index">
                    <img :src="item.icon" alt="" class="icon"/>
                    <p class="name">{{ item.name }}</p>
                </div>
            </template>
        </div>
        <div class="layout_main">
            <!--  -->
            <div class="wrapper">
                <!-- menu text -->
                <div class="top" v-if="menu[activeIndex].text">
                    <p class="desc">{{ menu[activeIndex].text }}</p>
                </div>
                <div class="vip_buy_list">
                    <p class="p1">立即成为 Ambassador<sup>+</sup>会员</p>
                    <p class="p2">三次观展即可收回会员费！邀请亲朋好友一起参加！</p>
                    <div class="vip_list">
                        <div class="item" v-for="(item, index) in viplist" :key="index" :class="{active: vipActiveIndex == index}" @click="vipActiveIndex = index">
                            <p class="name">{{ item.name }}</p>
                            <p class="price">¥{{ item.price }}</p>
                        </div>
                    </div>
                    <div class="btn" :class="{active: vipActiveIndex !== null}" @click="buyVip">立即购买</div>
                    <popup ref="popup" title="扫码支付" :show="isShowPopup" isShowClose @close="isShowPopup = false">
                        <div class="vip_pay">
                            <!-- 付款方式 -->
                            <div class="pay_type">
                                <p class="title">付款方式</p>
                                <div class="options flex">
                                    <div class="option flex align_center" v-for="(item, index) in payTypeList" :key="index" @click="choosePayType(item.id)">
                                        <div class="checkbox" :class="{ active: paytype == item.id }"></div>
                                        <p>{{ item.name }}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="qrcode layout_flex_center">
                                <p class="p2" v-if="isLoadingQrcode">加载中...</p>
                                <div v-else-if="payQrcode">
                                    <img :src="payQrcode" alt="支付二维码" class="qrcode_img"/>
                                    <p class="p2">请使用{{ payTypeList.find(item => item.id === paytype).name }}扫码支付</p>
                                </div>
                                <p class="p2" v-else>二维码加载失败，请重试</p>
                            </div>
                            <!-- 点击刷新 -->
                            <p class="btn pay_refresh" @click="refreshPayStatus">支付完成，点击刷新</p>
                        </div>
                    </popup>
                </div>
                <div class="top">
                    <p class="title">探索会员福利</p>
                    <p class="desc">立即以会员身份享受这些福利</p>
                </div>
                <router-link class="buy" to="buy" append>
                    <div class="layout_bg bg" :style="`background-image: url();`"></div>
                    <div class="content">
                        <p class="name">无限次免费参观展览<br/>--- 从今天开始</p>
                        <p class="desc">无需提前预订<br/>即使门票已售完，也可以参观展览<br/>免费携带最多四名 16 岁以下儿童</p>
                    </div>
                </router-link>
            </div>
            <!--  -->
            <div class="wrapper" v-if="detail.exhibition.length > 0">
                <div class="top">
                    <p class="title">正在上映</p>
                </div>
                <div class="exhibition_list flex flex_wrap">
                    <router-link class="item flex flex_column" v-for="(item, index) in detail.exhibition" :key="index" :to="`/gallery/latestNews/detail?id=${item.id}`">
                        <div class="layout_bg cover" :style="`background-image: url(${item.image});`"></div>
                        <div class="text flex flex_column">
                            <p class="type">{{ item.tag }}</p>
                            <p class="name">{{ item.name }}</p>
                            <div class="time flex align_start">
                                <img :src="require('@/assets/images/icon_calendar.png')" alt="" class="icon calendar"/>
                                <p>{{ item.time_text }}</p>
                            </div>
                            <div class="flex justify_between">
                                <div class="price flex align_center">
                                    <img :src="require('@/assets/images/icon_price.png')" alt="" class="icon price"/>
                                    <p>会员免费</p>
                                </div>
                                <div class="btn layout_flex_center only_pc">更多信息</div>
                            </div>
                        </div>
                    </router-link>
                </div>
            </div>
            <!--  -->
            <div class="wrapper" v-if="detail.study.length > 0">
                <div class="top">
                    <p class="title">课程与活动</p>
                </div>
                <StudyList :data="detail.study" type="type2"/>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.vip_buy_list{
    .p1{
        font-size: .2rem;
    }
    .p2{
        font-size: .18rem;
    }
    .vip_list{
        display: flex;
        gap: .4rem;
        margin: .3rem 0;
        @media screen and (max-width: 750px) {
            flex-direction: column;
            gap: .3rem;
        }
        .item{
            flex: 1;
            height: 2rem;
            border: 1px solid #999;
            padding: .3rem;
            cursor: pointer;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            @media screen and (max-width: 750px) {
                flex: auto;
            }
            &.active{
                border-color: #000;
            }
            .name{
                font-size: .24rem;
            }
            .price{
                font-size: .2rem;
                color: #666;
                text-align: right;
            }
        }
    }
    .btn{
        width: 1.8rem;
        height: .6rem;
        font-size: .2rem;
        color: #666;
        border: 1px solid #999;
        border-radius: .1rem;
        margin: 0 auto;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        &.active{
            border-color: var(--font_color);
            color: var(--font_color);
        }
        &.pay_refresh{
            width: 2.4rem;
            margin-top: .2rem;
            border-color: var(--font_color);
            color: var(--font_color);
        }
    }
    .pay_type{
        display: flex;
        align-items: center;
        margin-bottom: .4rem;
        .title{
            font-size: .25rem;
            font-weight: bold;
            margin-right: .2rem;
        }
        .options{
            font-size: .16rem;
            .option{
                cursor: pointer;
                margin-right: .3rem;
                .checkbox{
                    width: .24rem;
                    height: .24rem;
                    border: 1px solid var(--font_color);
                    border-radius: 50%;
                    margin-right: .1rem;
                    &.active{
                        &::after{
                            content: '';
                            display: block;
                            width: .16rem;
                            height: .16rem;
                            background-color: var(--font_color);
                            border-radius: 50%;
                            margin: .03rem;
                        }
                    }
                }
            }
        }
    }
    .qrcode{
        width: 4rem;
        margin: 0 auto;
        text-align: center;
        .qrcode_img{
            margin-bottom: .2rem;
        }
    }
}
.banner{
    height: 3.7rem;
    position: relative;
    .bg{
        position: absolute;
        z-index: -1;
    }
    .content{
        .text{
            font-size: .24rem;
            padding-top: 2.6rem;
        }
    }
    @media only screen and (max-width: 750px) {
        height: 4rem;
        .content{
            .text{
                padding-top: 3.1rem;
            }
        }
    }
}
.menu{
    border-top: 1px solid #666;
    border-bottom: 1px solid #666;
    height: 1.1rem;
    .item{
        width: 1rem;
        font-size: .18rem;
        position: relative;
        cursor: pointer;
        &::after{
            content: "";
            display: block;
            width: 100%;
            border-bottom: 2px solid #333;
            position: absolute;
            bottom: 0;
            left: 0;
            display: none;
        }
        &.active{
            &::after{
                display: flex;
            }
        }
        .icon{
            width: .45rem;
            height: .45rem;
            margin: 0 auto;
        }
    }
    @media only screen and (max-width: 750px) {
        height: 1.4rem;
        .item{
            width: 1.2rem;
            font-size: .2rem;
            .icon{
                width: .6rem;
                height: .6rem;
            }
        }
    }
}
.exhibition{
    padding: .35rem 0;
}
.wrapper{
    padding-bottom: .5rem;
}
.top{
    padding: .3rem 0;
    .title{
        font-size: .26rem;
        text-align: center;
    }
    .desc{
        text-align: center;
        font-size: .18rem;
    }
    @media only screen and (max-width: 750px) {
        .title{
            font-weight: bold;
        }
        .desc{
            font-size: .2rem;
        }
    }
}
.buy{
    height: 4.5rem;
    border: 1px solid #666;
    display: block;
    position: relative;
    @media only screen and (max-width: 750px) {
        height: 4rem;
    }
    .content{
        position: absolute;
        left: .4rem;
        bottom: .4rem;
        @media only screen and (max-width: 750px) {
            left: .3rem;
            bottom: .3rem;
        }
        .name{
            font-size: .3rem;
            margin-bottom: .2rem;
        }
        .desc{
            font-size: .16rem;
            line-height: 2;
            @media only screen and (max-width: 750px) {
                font-size: .18rem;
            }
        }
    }
}
.exhibition_list{
    gap: .54rem;
    .item{
        // width: 3.36rem;
        width: 3.64rem;
        @media only screen and (max-width: 750px) {
            width: 100%;
        }
        .cover{
            height: 0;
            padding-bottom: 80.36%;
            margin-bottom: .1rem;
            @media only screen and (max-width: 750px) {
                padding-bottom: 65.21%;
            }
        }
        .text{
            flex: 1;
            @media only screen and (max-width: 750px) {
                align-items: center;
            }
        }
        .type{
            font-size: .2rem;
            margin-bottom: .1rem;
            @media only screen and (max-width: 750px) {
                font-size: .26rem;
            }
        }
        .name{
            font-size: .24rem;
            margin-bottom: .1rem;
            @media only screen and (max-width: 750px) {
                font-size: .32rem;
            }
        }
        .time{
            font-size: .18rem;
            margin-bottom: .2rem;
            flex: 1;
            @media only screen and (max-width: 750px) {
                font-size: .22rem;
                // margin-bottom: 0;
            }
            .icon{
                margin-top: .02rem;
            }
        }
        .price{
            font-size: .18rem;
            @media only screen and (max-width: 750px) {
                font-size: .22rem;
            }
        }
        .icon{
            margin-right: .1rem;
            &.calendar{
                width: .21rem;
            }
            &.price{
                width: .24rem;
            }
            @media only screen and (max-width: 750px) {
                &.calendar{
                    width: .29rem;
                }
                &.price{
                    width: .32rem;
                }
            }
        }
        .btn{
            font-size: .18rem;
            color: #666;
            border: 1px solid #666;
            border-radius: .1rem;
            height: .35rem;
            padding: 0 .15rem;
            cursor: pointer;
        }
    }
}
</style>